import React, { useState } from "react";

import { AssessmentType } from "../../globals/types";
import useToken from "../../hooks/useToken";
import { authHeader, formsApi } from "../../lib/formsApi";
import { track } from "../../lib/track";
import { FeedbackModal } from "../FeedbackModal";

import { SubmittedModal } from "./SubmittedModal";

const FEEDBACK_SHOWN_KEY = "rfi-feedback-shown";

export const useSubmittedDialogs = (type: AssessmentType) => {
    const [open, setOpen] = useState(false);
    const [feedbackOpen, setFeedbackOpen] = useState(false);
    const submitRfiFeedback = formsApi.useMutation("post", "/api/rfi-feedback");
    const { token } = useToken();

    const show = () => {
        if (type === AssessmentType.External && !localStorage.getItem(FEEDBACK_SHOWN_KEY)) {
            localStorage.setItem(FEEDBACK_SHOWN_KEY, "true");
            setFeedbackOpen(true);
        } else {
            setOpen(true);
        }
    };

    const dialogs = (
        <>
            <FeedbackModal
                open={feedbackOpen}
                onClose={() => {
                    setFeedbackOpen(false);
                    setOpen(true);
                }}
                onSubmit={(rating, comment) => {
                    submitRfiFeedback.mutate({
                        headers: authHeader(token),
                        body: { rating, comment: comment ?? undefined },
                    });
                    track("Assessment form: Submitted feedback", {
                        rating,
                        hasComment: !!comment,
                        comment: comment ?? undefined,
                    });
                }}
            />
            <SubmittedModal open={open} type={type} />
        </>
    );

    return { show, dialogs };
};
